import React from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import AboutImg from "../../assets/images/about-img.jpg";
import IOSImg from "../../assets/images/services/ios.png";
import { faPlay, faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TechnologyWeUse from "../../assets/images/technology-we-use.jpg";
import { Link } from "react-router-dom";

export const IOSSec = () => {
  return (
    <>
      <div className="common-banner">
        <div className="container">
          <div className="banner-content">
            <h2>IOS</h2>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  IOS
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="about-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 about-left">
              <div className="about-img w-75 mx-auto">
                <img src={AboutImg} alt="about image" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="title">
                <h4>Build Cross-Platform Mobile Apps with React Native</h4>
                <h2>IOS Services</h2>
                <p>
                  IOS is a powerful framework developed by Facebook that enables
                  businesses to build mobile applications for both iOS and
                  Android platforms using a single codebase. It saves time and
                  resources while delivering a native-like performance,
                  providing a seamless user experience across devices.
                </p>
                <p>
                  At CodeInfoWay, we offer expert React Native development
                  services to help you launch high-performance mobile
                  applications that are scalable, secure, and feature-rich.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="why-choose-service pb-3 pb-lg-5">
        <div className="our-mission">
          <div className="title bg-dark py-5 px-5 mb-5 position-relative">
            <h4 className="text-center">
              Flexibility and Native Performance with React Native
            </h4>
            <h2 className="text-white text-center">Why Choose IOS?</h2>
            <div className="down-arrow">
              <FontAwesomeIcon icon={faPlay} />
            </div>
          </div>
        </div>
        <div className="container">
          <div className="why-choose-row row pt-5 pb-5 align-items-center">
            <div className="col-lg-4">
              <div className="card">
                <div className="card-body">
                  <h2>01</h2>
                  <h3>Cross-Platform Development</h3>
                  <p>
                    Write once, deploy across iOS and Android. React Native
                    allows developers to reuse most of the codebase, reducing
                    development time and costs.
                  </p>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <h2>02</h2>
                  <h3>Cross-Platform Development</h3>
                  <p>
                    Write once, deploy across iOS and Android. React Native
                    allows developers to reuse most of the codebase, reducing
                    development time and costs.
                  </p>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <h2>03</h2>
                  <h3>Cross-Platform Development</h3>
                  <p>
                    Write once, deploy across iOS and Android. React Native
                    allows developers to reuse most of the codebase, reducing
                    development time and costs.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <img src={IOSImg} alt="React Native Services" className="px-4" />
            </div>
            <div className="col-lg-4">
              <div className="card">
                <div className="card-body">
                  <h2>04</h2>
                  <h3>Cross-Platform Development</h3>
                  <p>
                    Write once, deploy across iOS and Android. React Native
                    allows developers to reuse most of the codebase, reducing
                    development time and costs.
                  </p>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <h2>05</h2>
                  <h3>Cross-Platform Development</h3>
                  <p>
                    Write once, deploy across iOS and Android. React Native
                    allows developers to reuse most of the codebase, reducing
                    development time and costs.
                  </p>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <h2>06</h2>
                  <h3>Cross-Platform Development</h3>
                  <p>
                    Write once, deploy across iOS and Android. React Native
                    allows developers to reuse most of the codebase, reducing
                    development time and costs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="technology-sec py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="title">
                <h4>Empowering Innovation with Cutting-Edge Technologies</h4>
                <h2>Technologies We Use</h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="title">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-0 mt-lg-5">
            <div className="col-lg-6">
              <div className="title">
                <ul>
                  <li>
                    <FontAwesomeIcon icon={faSquareCheck} className="me-2" />
                    React Native
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faSquareCheck} className="me-2" />
                    Redux
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faSquareCheck} className="me-2" />
                    TypeScript
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faSquareCheck} className="me-2" />
                    Firebase
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faSquareCheck} className="me-2" />
                    GraphQL
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faSquareCheck} className="me-2" />
                    REST APIs
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faSquareCheck} className="me-2" />
                    Native Modules (iOS & Android)
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-img w-75 mx-auto">
                <img src={TechnologyWeUse} alt="about image" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cta-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2>Ready to Build Your Mobile App with IOS?</h2>
              <Link to="#" className="btn btn-primary mt-3">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
